module.exports = __webpack_public_path__ + "static/media/arrow-down-blue.70fff296.svg";